/** Display access duration independently from the legacy trial date. */
export function adminAccessValidity(user = {}) {
  if (user.role === 'admin') return { label: 'Administrador · sin vencimiento', end: null };
  const access = user.access_policy;
  if (access) {
    if (access.is_paid) return { label: 'Suscripción', end: access.paid_ends_at };
    return { label: access.free_ends_at ? 'Acceso gratuito' : 'Gratis sin vencimiento', end: access.free_ends_at };
  }
  // Older admin responses include the persisted free policy but not access_policy.
  if (['subscribed', 'active', 'cancelled'].includes(user.subscription_status) && user.trial_end_date) {
    return { label: 'Vigencia pagada registrada', end: user.trial_end_date };
  }
  if (user.free_access_days === 0) return { label: 'Gratis sin vencimiento', end: null };
  const started = new Date(user.free_access_started_at).getTime();
  if (user.free_access_days > 0 && Number.isFinite(started)) {
    return { label: 'Acceso gratuito', end: new Date(started + user.free_access_days * 86400000).toISOString() };
  }
  return { label: 'Vigencia por verificar', end: null };
}

export default function AdminAccessValidity({ user, formatDate }) {
  const { label, end } = adminAccessValidity(user);
  return <span>{end ? <>{formatDate(end)}<span className="block text-xs text-slate-500">{label}</span></> : label}</span>;
}
